// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setStartDate = createAction('[Scatter Plot] Set Start Date', props());
